<template>
    <tailwind-layout title="Employment Verification">
        <template #header>
            <boost-header
                title="Employment Verification"
                subtitle="Connect your payroll or employment account to quickly and securely verify your job and income details."
                :report-id="report.id"
            />
        </template>

        <div class="rounded-md lg:shadow shadow-none overflow-x-auto">
            <div class="shadow overflow-hidden lg:border">
                <table class="min-w-full divide-y divide-gray-300">
                    <thead class="bg-blue-50">
                        <tr>
                            <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">Type</th>
                            <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left">Status</th>
                            <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-gray-900 text-left"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="bg-gray-50 border-b">
                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">Employment Verification</td>
                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900" data-test="status">
                                {{ verified ? 'Added' : 'Not Added' }}
                            </td>
                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                <button v-if="!verified" type="button" class="text-blue-600" data-test="add" @click="start">
                                    Add
                                </button>
                                <a
                                    v-else-if="has_income_report"
                                    target="_blank"
                                    :href="route('user-payroll-income.load')"
                                    class="text-blue-600"
                                    data-test="view"
                                >
                                    View
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <full-page-loader v-if="isLoader" />
    </tailwind-layout>
</template>

<script>
import axios from 'axios'
import { router } from '@inertiajs/vue3'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import FullPageLoader from '@/Shared/FullPageLoader.vue'
import BoostHeader from './BoostHeader.vue'
import { openPlaidLink } from './plaidLink'

/**
 * 86bc8uyd2: the Applicant Boost's employment step. A copy of
 * EmploymentVerification/EmploymentVerification.vue that saves against the report.
 */
export default {
    components: {
        TailwindLayout,
        FullPageLoader,
        BoostHeader,
    },
    props: {
        report: {
            type: Object,
            required: true,
        },
        verified: {
            type: Boolean,
            default: false,
        },
        has_income_report: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoader: false,
        }
    },
    methods: {
        async start() {
            this.isLoader = true
            try {
                await axios.get('/sanctum/csrf-cookie')
                const response = await axios.post(route('user-document-income.create-link-token'), {
                    income_source_type: 'payroll',
                })
                this.isLoader = false
                if (response.data.status) {
                    openPlaidLink(response.data.public_token, {
                        onSuccess: (publicToken, metadata) => this.finish(publicToken, metadata),
                    })
                }
            } catch (error) {
                this.isLoader = false
                console.error('Error:', error.response ? error.response.data : error.message)
            }
        },
        async finish(publicToken, metadata) {
            this.isLoader = true
            try {
                await axios.post(route('reports.boost.employment.save', this.report.id), {
                    public_token: publicToken,
                    metadata,
                })
            } catch (error) {
                console.error('Error:', error.response ? error.response.data : error.message)
            } finally {
                this.isLoader = false
                router.reload()
            }
        },
    },
}
</script>
